import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export function initHeroAnimations(): void {
  const heart = document.getElementById('heart')
  const hand = document.getElementById('hand')
  const heroSection = document.getElementById('hero')
  const navText = document.querySelector('.hero__nav-text')
  const letterMasks = document.querySelectorAll('.letter-mask')

  if (!heart || !hand || !heroSection) return

  // Force scroll to top on page load to prevent scroll restoration triggering animations
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual'
  }
  window.scrollTo(0, 0)

  // Ensure hand and heart start at correct position on load
  gsap.set(hand, { y: 0 })
  gsap.set(heart, { yPercent: -50, xPercent: -50 })

  // Letter mask reveal animation - smooth bottom to top reveal
  if (letterMasks.length > 0) {
    // Set initial state: masks start with 0 height from bottom
    gsap.set(letterMasks, { 
      attr: { height: 0, y: 462 } // Start at bottom with 0 height
    })

    // Animate each letter with stagger - reveal from bottom to top
    gsap.to(letterMasks, {
      attr: { height: 462, y: 0 }, // Full height, back to top
      duration: 1.2,
      ease: 'power4.out',
      stagger: 0.15, // Delay between each letter
      delay: 0.2, // Small initial delay
    })
  }

  // Nav text slide down animation on load (smooth like osmo.supply)
  if (navText) {
    gsap.fromTo(
      navText,
      { y: -100 },
      { y: 0, duration: 1.2, ease: 'power3.out', delay: 0.4 }
    )
  }

  // Note: Heart rotation is now handled by Three.js in heart-3d.ts
  // The 3D heart rotates continuously around the Y-axis for a flip effect

  // Hand animation - triggers quickly when user starts scrolling
  // Goes down fast, comes back fast when scrolling up
  ScrollTrigger.create({
    trigger: heroSection,
    start: '+=1', // Start after 1px of scroll (not at top top)
    end: '+=100',
    onEnter: () => {
      gsap.to(hand, {
        y: '100vh',
        duration: 0.6,
        ease: 'power3.in',
      })
    },
    onLeaveBack: () => {
      gsap.to(hand, {
        y: 0,
        duration: 0.4,
        ease: 'power2.out',
      })
    },
  })

  // Heart animation - stays longer, goes down a tiny bit first, then exits up
  ScrollTrigger.create({
    trigger: heroSection,
    start: '+=1', // Start after 1px of scroll
    end: '+=150',
    onEnter: () => {
      // First, move down a tiny bit (using yPercent since it's centered with transform)
      gsap.to(heart, {
        yPercent: -45, // Moves down slightly from center (-50%)
        duration: 0.3,
        ease: 'power2.out',
      })
    },
    onLeaveBack: () => {
      gsap.to(heart, {
        yPercent: -50, // Back to center
        duration: 0.3,
        ease: 'power2.out',
      })
    },
  })

  // Heart exits up after more scrolling
  ScrollTrigger.create({
    trigger: heroSection,
    start: '+=200', // After 200px of scroll
    end: '+=100',
    onEnter: () => {
      gsap.to(heart, {
        yPercent: -250, // Exit up
        duration: 0.8,
        ease: 'power3.in',
      })
    },
    onLeaveBack: () => {
      // Come back down to the slight offset position
      gsap.to(heart, {
        yPercent: -45,
        duration: 0.4,
        ease: 'power2.out',
      })
    },
  })

  // When scrolling back to very top, reset heart to original position
  ScrollTrigger.create({
    trigger: heroSection,
    start: 'top top',
    end: '+=50',
    onLeaveBack: () => {
      gsap.to(heart, {
        yPercent: -50,
        duration: 0.3,
        ease: 'power2.out',
      })
    },
  })
}
